import { Injectable } from '@angular/core';
import { NavigationExtras, Params, Route, Router } from '@angular/router';

/**
 * Insert here and in the Urlservice.TREE object all the url branches of the app
 */
export type BranchName = ''
	| 'confirm-email'
	| 'file'
	| 'help'
	| 'info'
	| 'login'
	| 'logout'
	| 'onboarding'
	| 'profile'
	| 'recover-password'
	| 'reset-password'
	| 'signup'
	| 'terms'
	| 'trip'
	| 'trip/detail'
	| 'trip/support'
	;

interface NaarGoRoute extends Route {
	path: BranchName;
}
export type NaarGoRoutes = NaarGoRoute[];

type UrlTreeBranch = {
	url: string,
	segmentsKeys?: string[],
	queryParamsKeys?: string[]
};

export type TreeObject = UrlTreeBranch & {
	navigate: (params?: Record<string, string>, extras?: NavigationExtras) => void;
};

@Injectable({
	providedIn: 'root'
})
export class UrlService {
	private readonly TREE: Record<BranchName, UrlTreeBranch> = {
		'': { url: '' },
		'onboarding': { url: '/welcome' },
		'confirm-email': { url: '/confirm-email', queryParamsKeys: ['email'] },
		'file': { url: '/file' },
		'help': { url: '/help'},
		'info': { url: '/info' },
		'login': { url: '/login', queryParamsKeys: ['returnUrl'] },
		'logout': { url: '/logout' },
		'profile': { url: '/profile' },
		'recover-password': { url: '/recover-password' },
		'reset-password': { url: '/reset-password', queryParamsKeys: ['email'] },
		'signup': { url: '/signup' },
		'terms': { url: '/terms' },
		'trip': { url: '/trip', queryParamsKeys: ['tId'] },
		'trip/detail': { url: '/trip/detail', queryParamsKeys: ['sId'] },
		'trip/support': { url: '/trip/support' },
	}

	constructor(
		private router: Router,
	) {
	}

	public get(path: BranchName): TreeObject {
		const branch = this.TREE[path];

		return {
			...branch,
			navigate: (params: Record<string, string> = {}, extras: NavigationExtras = {}) => {
				params = params || {};
				const segments = branch.segmentsKeys?.map(key => params[key]) || [];
				const queryParams: Params = branch.queryParamsKeys?.reduce((acc, key) => {
					acc[key] = params[key];
					return acc;
				}, {}) || {};

				this.router.navigate([branch.url, ...segments], {
					queryParams: queryParams,
					...extras,
				});
			},
		};
	}

	public parse(url: string) {
		return this.router.parseUrl(url);
	}
}